module.exports = __webpack_public_path__ + "img/thigh.8ac62312.png";